import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import {
  Input,
  InputGroup,
  Button,
  CheckPicker,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Table,
  Container,
  Notification,
  Checkbox,
  IconButton
} from 'rsuite';
import VisibleIcon from '@rsuite/icons/Visible';
import SearchIcon from '@rsuite/icons/Search';
import { Link, useLocation } from 'react-router-dom';
import globalIP from '../../GlobelIP';
import ugr from '@/UGRoute';

const { Column, HeaderCell, Cell } = Table;

const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div style={{ lineHeight: '46px' }}>
      <Checkbox
        value={rowData[dataKey]}
        inline
        onChange={onChange}
        checked={checkedKeys.some(item => item === rowData[dataKey])}
      />
    </div>
  </Cell>
);

const MngMarketing = () => {


  const ip = globalIP;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('selectedItems') || '';
  const selectedItemsArray = selectedItems.split(',');

  const [data1234, setData1234] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch(`${ip}/api/products?populate=*`);
    const json = await response.json();
    const filtereddData = json.data.filter(item => selectedItemsArray.includes(String(item.id)));
    setData1234(filtereddData);
  };
  
 
  const [buyerdata, setBuyerdata] = useState([]);
  useEffect(() => {
    fetchData2();
  }, [buyerdata]);
  const fetchData2 = async () => {
    const response = await fetch(`${ip}/api/buyer-details?populate=*`);
    const json = await response.json();
    setBuyerdata(json.data);
  };



  const [checkedKeys, setCheckedKeys] = React.useState([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === buyerdata.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < buyerdata.length) {
    indeterminate = true;
  }


  const handleCheck = (value, checked) => {
    const keys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);
    setCheckedKeys(keys);
  };




  const [companydataa, setCompanydataa] = useState([]);
  useEffect(() => {
    fetchData6();
  }, [companydataa]);
  const fetchData6 = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-companies`);
      const json = await response.json();
      // Extract unique company names using Set to eliminate duplicates
      const uniqueCompanyNames = new Set(
        json.data.map((item) => item.attributes.companynm)
      );
      // Convert Set back to an array of objects with label and value keys
      const processedData = Array.from(uniqueCompanyNames).map((companyName) => ({
        label: companyName,
        value: companyName,
      }));
      setCompanydataa(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [selectedCompany, setSelectedCompany] = useState([]);
  const handleComapnyChange = (value) => {
    setSelectedCompany(value);
  };

  const [searchQuery, setSearchQuery] = useState('');
  const handleSearch = (value) => {
    setSearchQuery(value);
  };
  const [isCartOpen, setIsCartOpen1] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const handleCartClose = () => {
    setIsCartOpen1(false);
  };
  const handleCheckboxChange = (rowId, checked) => {
    if (checked) {
      setSelectedRowIds((prevSelectedRowIds) => [...prevSelectedRowIds, rowId]);
    } else {
      setSelectedRowIds((prevSelectedRowIds) =>
        prevSelectedRowIds.filter((selectedRowId) => selectedRowId !== rowId)
      );
    }
  };
  const handleCheckAll = (value, checked) => {
    if (checked) {
      // Select all items
      setSelectedRowIds(buyerdata.map((row) => row.id));
    } else {
      // Deselect all items
      setSelectedRowIds([]);
    }
  };


const [tableHeight, setTableHeight] = useState(20); // Default height
      useEffect(() => {
        const calculateHeight = () => {
          const headerHeight = 290; // Adjust based on your header/footer size
          const footerHeight = 5; // Adjust based on your footer size
          const availableHeight = window.innerHeight - headerHeight - footerHeight;
          setTableHeight(availableHeight);
        };
        calculateHeight();
        window.addEventListener('resize', calculateHeight); // Recalculate on window resize
        return () => window.removeEventListener('resize', calculateHeight);
      }, []);

  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar market-head" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start' className='mng-mrk-main'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Manage Marketing</h3>
              <Breadcrumb>
              <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>
                    Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item active>Manage Marketing</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={5}>
              <CheckPicker
                data={companydataa}
                placeholder="Buyer Company Name"
                labelKey="label"
                value={selectedCompany}
                onChange={handleComapnyChange}
                valueKey="value"
                size="md"
                appearance="default"
                className='mng-market'
              />
            </Stack>
          </Stack>

          <Stack  alignItems='flex-end' spacing={16}  className='mng-mrk-srch'>
            <Stack direction='row' spacing={5}>
              <InputGroup inside  className='mng-market'>
                <Input placeholder="Search" type="text" value={searchQuery} onChange={handleSearch} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>

       
           
              {/* <Checkbox
                indeterminate={selectedItems.length > 0 && selectedItems.length < data123.length}
                checked={selectedItems.length === data123.length}
                onChange={handleCheckAll}
              >
                Select all
              </Checkbox> */}
              
            </Stack>
          </Stack>
        </Stack>
        <Divider className='divide' style={{marginTop: '10px'}}/>
        <div className="row">
          <Panel>

            <Table height={tableHeight} data={buyerdata.filter(item => {
              const companynamem = item.attributes.companynm.toLowerCase();
              const byuernamem = item.attributes.buyernm.toLowerCase();
              const ContNo = item.attributes.contactno.toLowerCase();
              const email = item.attributes.email.toLowerCase();
              const country = item.attributes.country.toLowerCase();

              const camponyname = item.attributes.companynm;
              const categoryMatch = selectedCompany.length === 0 || selectedCompany.includes(camponyname);

              return (companynamem.includes(searchQuery.toLowerCase()) ||
                byuernamem.includes(searchQuery.toLowerCase()) || ContNo.includes(searchQuery.toLowerCase()) ||
                email.includes(searchQuery.toLowerCase()) || country.includes(searchQuery.toLowerCase()))
                && categoryMatch
            })}
              rowHeight={60}
              rowKey="id"
              bordered
              cellBordered
            >
              <Column width={100}>
                <HeaderCell style={{ padding: 0 }}>
                  <div style={{ lineHeight: '40px' }}>
                    <Checkbox
                      inline
                      checked={selectedRowIds.length === buyerdata.length}
                      indeterminate={selectedRowIds.length > 0 && selectedRowIds.length < buyerdata.length}
                      onChange={handleCheckAll}
                    />

                  </div>
                </HeaderCell>
                <CheckCell
                  dataKey="id"
                  checkedKeys={selectedRowIds}
                  onChange={(rowId, checked) => handleCheckboxChange(rowId, checked)}
                  rowData={undefined}
                />
              </Column>

              <Column width={160}>
                <HeaderCell><b>Buyer Company Name</b></HeaderCell>
                <Cell dataKey={'attributes.companynm'} />
              </Column>
              <Column width={160}>
                <HeaderCell><b>Buyer Name</b></HeaderCell>
                <Cell dataKey={'attributes.buyernm'} />
              </Column>
              <Column width={160}>
                <HeaderCell><b>Country</b></HeaderCell>
                <Cell dataKey={'attributes.country'} />
              </Column>
              <Column width={160}>
                <HeaderCell><b>Email</b></HeaderCell>
                <Cell dataKey={'attributes.email'} />
              </Column>
              <Column flexGrow={1}>
                <HeaderCell><b>Address</b></HeaderCell>
                <Cell dataKey={'attributes.address'} />
              </Column>
              <Column width={160}>
                <HeaderCell><b>Contact No.</b></HeaderCell>
                <Cell dataKey={'attributes.contactno'} />
              </Column>
            </Table>
          </Panel>
          {selectedRowIds.length > 0 && (
            <Notification
              type="success"
              onClose={handleCartClose}
              style={{
                position: 'fixed',
                top: '80%',
                right: 20,
                transform: 'translateY(-50%)',
                zIndex: 9999,
                background: '#0070a9',
                color: 'white',
               
              }}
              className='view'
            >
              <b style={{ color: 'white' }}>Selected Buyers: {selectedRowIds.length}</b>
              <Divider />
              <Link
                to={{ pathname: `/${ugr}/generateMark`, search: `?selectedItems=${selectedItemsArray.join(',')}&bid=${selectedRowIds.join(',')}` }}
              >
                <IconButton icon={<VisibleIcon />}><b>Next</b></IconButton>
              </Link>
            </Notification>
          )}
        </div>


        <Stack className="copyright"    justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
          <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERPDaddy Software Solution.</a></p>
        </Stack>

      </Container>
    </>
  );
};
export default MngMarketing;

